export const defaultBodyColor = '#FFAE7B';

export const defaultBackgroundColors = {
  primary: '#1D655C',
  secondary: '#2A9D8F',
};

export const defaultSchema = {
  colors: {
    background: defaultBackgroundColors,
    cat: { primary: defaultBodyColor, secondary: '#754F44' },
  },
};
